(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-instagram-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ig-videos')) {
    class IgVideos extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.igv__track');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');

        this.addEventListener('click', this.onClick);

        if (this.track && this.prev && this.next) {
          this.prev.addEventListener('click', () => this.scrollPage(-1));
          this.next.addEventListener('click', () => this.scrollPage(1));
          this.track.addEventListener('scroll', this.updateArrows, { passive: true });
          this.resizeObserver = new ResizeObserver(this.updateArrows);
          this.resizeObserver.observe(this.track);
          this.updateArrows();
        }

        this.initLazyIframes();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        if (this.track) this.track.removeEventListener('scroll', this.updateArrows);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.io) this.io.disconnect();
      }

      pauseAll(except) {
        this.querySelectorAll('video').forEach((v) => {
          if (v !== except && !v.paused) v.pause();
        });
      }

      onClick = (e) => {
        const btn = e.target.closest('button.igv__play');
        if (!btn) return;
        const frame = btn.closest('.igv__frame');
        const video = frame && frame.querySelector('video');
        if (!video) return;

        // Lazy-set source on first play
        if (!video.getAttribute('src')) {
          video.src = video.dataset.src;
          video.load();
        }

        this.pauseAll(video);
        video.controls = true;
        frame.classList.add('is-playing');

        const reset = () => {
          video.controls = false;
          frame.classList.remove('is-playing');
        };
        video.addEventListener('ended', reset, { once: true });
        video.addEventListener('error', reset, { once: true });

        const p = video.play();
        if (p && p.catch) p.catch(reset);
      };

      updateArrows = () => {
        const t = this.track;
        this.prev.disabled = t.scrollLeft <= 1;
        this.next.disabled = t.scrollLeft >= t.scrollWidth - t.clientWidth - 1;
      };

      scrollPage(dir) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({
          left: dir * this.track.clientWidth * 0.9,
          behavior: reduce ? 'auto' : 'smooth'
        });
      }

      initLazyIframes() {
        const frames = this.querySelectorAll('iframe[data-src]');
        if (!frames.length) return;
        const load = (f) => { f.src = f.dataset.src; f.removeAttribute('data-src'); };

        if (!('IntersectionObserver' in window)) {
          frames.forEach(load);
          return;
        }
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              load(entry.target);
              this.io.unobserve(entry.target);
            }
          });
        }, { rootMargin: '300px' });
        frames.forEach((f) => this.io.observe(f));
      }
    }
    customElements.define('ig-videos', IgVideos);
  }

  } catch(e) { console.error(e); }
})();
})();
